<template>
    <div class="s-team p-cta">
      <div class="s-team-filter">
        <ul class="s-team-categories">
          <!-- <li class="s-team-category" data-type="all">All</li> -->
          <li class="s-team-category" data-type="investment">Investment Professionals</li>
          <li class="s-team-category" data-type="operations">Senior Business Professionals</li>
        </ul>
      </div>
      <div class="s-team-list">

        <router-link class="s-team-row" data-type="senior-leadership" to="/people/richard-deitz">
          <div class="s-team-col">
            <h3 class="f-md">Richard Deitz</h3>
            <p class="f-xs">
              Founder &amp; President
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/richard-deitz.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="investment" to="/people/richard-deitz">
          <div class="s-team-col">
            <h3 class="f-md">Richard Deitz</h3>
            <p class="f-xs">
              Founder &amp; President
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/richard-deitz.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="senior-leadership" to="/people/jeffrey-johnson">
          <div class="s-team-col">
            <h3 class="f-md">Jeffrey Johnson</h3>
            <p class="f-xs">
              Managing Partner
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/jeffrey-johnson.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="operations" to="/people/jeffrey-johnson">
          <div class="s-team-col">
            <h3 class="f-md">Jeffrey Johnson</h3>
            <p class="f-xs">
              Managing Partner
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/jeffrey-johnson.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="senior-leadership" to="/people/gustavo-palazzi">
          <div class="s-team-col">
            <h3 class="f-md">Gustavo Palazzi</h3>
            <p class="f-xs">
              Senior Portfolio Manager
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/gustavo-palazzi.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="investment" to="/people/gustavo-palazzi">
          <div class="s-team-col">
            <h3 class="f-md">Gustavo Palazzi</h3>
            <p class="f-xs">
              Senior Portfolio Manager
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/gustavo-palazzi.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="senior-leadership" to="/people/david-thompson">
          <div class="s-team-col">
            <h3 class="f-md">David Thompson</h3>
            <p class="f-xs">
              Senior Portfolio Manager
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/david-thompson.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="investment" to="/people/david-thompson">
          <div class="s-team-col">
            <h3 class="f-md">David Thompson</h3>
            <p class="f-xs">
              Senior Portfolio Manager
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/david-thompson.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="investment" to="/people/oleg-kotov">
          <div class="s-team-col">
            <h3 class="f-md">Oleg Kotov</h3>
            <p class="f-xs">
              Senior Portfolio Manager
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/oleg-kotov.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="investment" to="/people/sergey-makhin">
          <div class="s-team-col">
            <h3 class="f-md">Sergey Makhin</h3>
            <p class="f-xs">
              Senior Portfolio Manager
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/sergey-makhin.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="investment" to="/people/eric-carlson">
          <div class="s-team-col">
            <h3 class="f-md">Eric Carlson</h3>
            <p class="f-xs">
              Senior Portfolio Manager
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/eric-carlson.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="investment" to="/people/martin-mojzis">
          <div class="s-team-col">
            <h3 class="f-md">Martin Mojžiš</h3>
            <p class="f-xs">
              Managing Director & Head Investment Counsel
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/martin-mojzis.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="investment" to="/people/sergio-revilla-cornejo">
          <div class="s-team-col">
            <h3 class="f-md">Sergio Revilla Cornejo</h3>
            <p class="f-xs">
              Portfolio Manager
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/sergio-revilla-cornejo.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="investment" to="/people/evgeny-vasilyev">
          <div class="s-team-col">
            <h3 class="f-md">Evgeny Vasilyev</h3>
            <p class="f-xs">
              Portfolio Manager
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/evgeny-vasilyev.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="investment" to="/people/grigory-arkadyev">
          <div class="s-team-col">
            <h3 class="f-md">Grigory Arkadyev</h3>
            <p class="f-xs">
              Director
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/grigory-arkadyev.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>


        <router-link class="s-team-row" data-type="investment" to="/people/jae-chung">
          <div class="s-team-col">
            <h3 class="f-md">Jae Chung</h3>
            <p class="f-xs">
              Senior Investment Counsel
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/jae-chung.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="investment" to="/people/alejandro-lenardon">
          <div class="s-team-col">
            <h3 class="f-md">Alejandro Lenardon</h3>
            <p class="f-xs">
              Associate
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/alejandro-lenardon.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="investment" to="/people/oliver-weiss">
          <div class="s-team-col">
            <h3 class="f-md">Oliver Weiss</h3>
            <p class="f-xs">
              Analyst
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/oliver-weiss.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>


        <router-link class="s-team-row" data-type="investment" to="/people/urjil-sanghvi">
          <div class="s-team-col">
            <h3 class="f-md">Urjil Sanghvi</h3>
            <p class="f-xs">
              Analyst
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/urjil-sanghvi.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="senior-leadership" to="/people/ashok-raju">
          <div class="s-team-col">
            <h3 class="f-md">Ashok Raju</h3>
            <p class="f-xs">
              Chief Operating Officer
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/ashok-raju.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="operations" to="/people/ashok-raju">
          <div class="s-team-col">
            <h3 class="f-md">Ashok Raju</h3>
            <p class="f-xs">
              Chief Operating Officer
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/ashok-raju.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="senior-leadership" to="/people/emile-du-toit">
          <div class="s-team-col">
            <h3 class="f-md">Emile du Toit</h3>
            <p class="f-xs">
              Chief Financial Officer
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/emile-du-toit.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="operations" to="/people/emile-du-toit">
          <div class="s-team-col">
            <h3 class="f-md">Emile du Toit</h3>
            <p class="f-xs">
              Chief Financial Officer
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/emile-du-toit.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="senior-leadership" to="/people/dustin-mommen">
          <div class="s-team-col">
            <h3 class="f-md">Dustin Mommen</h3>
            <p class="f-xs">
              Chief Technology Officer
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/dustin-mommen.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="operations" to="/people/dustin-mommen">
          <div class="s-team-col">
            <h3 class="f-md">Dustin Mommen</h3>
            <p class="f-xs">
              Chief Technology Officer
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/dustin-mommen.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="senior-leadership" to="/people/stephen-penner">
          <div class="s-team-col">
            <h3 class="f-md">Stephen Penner</h3>
            <p class="f-xs">
              General Counsel
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/stephen-penner.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="operations" to="/people/stephen-penner">
          <div class="s-team-col">
            <h3 class="f-md">Stephen Penner</h3>
            <p class="f-xs">
              General Counsel
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/stephen-penner.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="senior-leadership" to="/people/fredrik-olsson">
          <div class="s-team-col">
            <h3 class="f-md">Fredrik Olsson</h3>
            <p class="f-xs">
              Chief Compliance Officer and Legal Counsel
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/fredrik-olsson.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="operations" to="/people/fredrik-olsson">
          <div class="s-team-col">
            <h3 class="f-md">Fredrik Olsson</h3>
            <p class="f-xs">
              Chief Compliance Officer and Legal Counsel
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/fredrik-olsson.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>
        <router-link class="s-team-row" data-type="operations" to="/people/linda-astakhova">
          <div class="s-team-col">
            <h3 class="f-md">Linda Astakhova</h3>
            <p class="f-xs">
              Managing Director &amp; Head of Operations
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/linda-astakhova.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="operations" to="/people/val-neyman">
          <div class="s-team-col">
            <h3 class="f-md">Val Neyman</h3>
            <p class="f-xs">
              Managing Director &amp; Head of Analytics
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/val-neyman.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>

        <router-link class="s-team-row" data-type="operations" to="/people/thomas-ginakakis">
          <div class="s-team-col">
            <h3 class="f-md">Thomas Ginakakis</h3>
            <p class="f-xs">
              Managing Director & Head of Investor Relations and Business Development
            </p>
          </div>
          <div class="s-team-col">
            <div class="s-team-picture"
                 :style="{
                backgroundImage: 'url(/images/people/thomas-ginakakis.jpg)',
              }"></div>
          </div>
          <div class="s-team-indicator"></div>
        </router-link>
      </div>
    </div>
</template>

<script>
import Team from './team';

let team;

export default {
  mounted() {
    team = new Team();
    team.init();
  },
  destroyed() {
    team.destroy();
  },
};
</script>
